import { showFailed } from "../../CommonFunction/SweetAlert";
import { QuerySelector2 } from "./QuerySelector";

export const fetchOutboxList = async (jwtToken, paginationData, searchQuery, bankID, branchID, role) => {
    try {
        const query = QuerySelector2(
            paginationData,
            searchQuery,
            bankID,
            branchID,
            role
          );
        const response = await fetch(
            `${process.env.REACT_APP_PLATFORM_API_BASE_URL}/dashboard/bank/outbox?${query}`,
            {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${jwtToken}`,
                },
            }
        );
        const data = await response.json();
        if (response.ok) {
            return data;
        } else {
            showFailed(`Failed.`, `${data?.error[0]}`);
        }
    } catch (error) {
        showFailed('Failed to load data.', error);
    }
};